import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmAlertButtonDirective, ConfirmAlertCheckbox, ConfirmAlertComponent } from './confirm-alert.component';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { DfAlertModule } from '@design-factory/design-factory';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, NgbAlertModule, DfAlertModule],
  declarations: [ConfirmAlertComponent, ConfirmAlertButtonDirective, ConfirmAlertCheckbox],
  exports: [ConfirmAlertComponent, ConfirmAlertButtonDirective, ConfirmAlertCheckbox]
})
export class ConfirmAlertModule {}
